import { ReactNode, useEffect, useRef, useState } from 'react';
import Marquee from 'react-fast-marquee';

export default function Component({
  playing = true,
  children,
}: {
  playing?: boolean;
  children: ReactNode;
}) {
  const content = useRef<HTMLDivElement>(null);
  const [isMarquee, setIsMarquee] = useState(false);

  useEffect(() => {
    // Assumes mounted
    const elem = content.current;
    const parent = elem?.parentElement;
    if (elem && parent) {
      setIsMarquee(elem.offsetWidth > parent.offsetWidth);
    } else {
      setIsMarquee(false);
    }
  }, []);

  const contents = (
    <div
      className={`${isMarquee ? 'mr-6' : ''} whitespace-nowrap`}
      ref={content}
    >
      {children}
    </div>
  );

  if (isMarquee) {
    return (
      <Marquee speed={25} play={playing} gradient gradientWidth={10}>
        {contents}
      </Marquee>
    );
  }

  return contents;
}
